"use client";

import React from "react";
import styles from "./premium-characteristics.module.css";
import { ListingData } from "@/types/types";

interface PremiumCharacteristicsProps {
  listingData: ListingData;
}

export default function PremiumCharacteristics({
  listingData,
}: PremiumCharacteristicsProps) {
  // Helper to format category/type text nicely
  const formatType = (str?: string | null) => {
    if (!str) return null;
    return str.charAt(0).toUpperCase() + str.slice(1).replace("-", " ");
  };

  // Build the list dynamically so we don't render empty rows
  const characteristics = [
    { label: "Tip proprietate", value: formatType(listingData.type) },
    { label: "Compartimentare", value: "Decomandat" }, // Mocked based on screenshot
    {
      label: "Suprafață construită",
      value: listingData.total_structure_area
        ? `${listingData.total_structure_area} mp`
        : null,
    },
    { label: "Orientare", value: listingData.orientation || "Sud" }, // Mocked based on screenshot
    {
      label: "Încălzire",
      value: listingData.facilities?.has_ac ? "Pardoseală" : "Centrală proprie",
    }, // Mocked
    { label: "Confort", value: listingData.is_luxury ? "Lux" : "1" },
    {
      label: "Aer condiționat",
      value: listingData.facilities?.has_ac ? "Da" : "Nu",
    },
    {
      label: "Lift",
      value: listingData.facilities?.has_elevator ? "Da" : "Nu",
    },
    {
      label: "Disponibilitate",
      value: listingData.available_from ? "Imediat" : null,
    },
  ].filter((item) => item.value); // Remove items with null/undefined values

  return (
    <div className={styles.card}>
      <h2 className={styles.title}>Caracteristici principale</h2>

      <div className={styles.grid}>
        {characteristics.map(
          (char, index) =>
            char.value !== null && (
              <div key={index} className={styles.row}>
                <span className={styles.label}>{char.label}</span>
                <span className={styles.value}>{char.value.toString()}</span>
              </div>
            ),
        )}

        {/* Special handling for EPC (Clasă energetică) badge */}
        {listingData.epc && (
          <div className={styles.row}>
            <span className={styles.label}>Clasă energetică</span>
            <span className={styles.value}>
              <span
                className={`${styles.epcBadge} ${styles[`epc${listingData.epc}`] || ""}`}
              >
                {listingData.epc}
              </span>
            </span>
          </div>
        )}
      </div>
    </div>
  );
}
